
import React, { useMemo } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import { REGEXPS } from '@/common';
import getYearsOldTitle from '@/utils/modifiers/getYearsOldTitle';

interface Props {
  birthOn: string;
  relationship?: string;
  fullName?: string;
}

const DependentsAge: React.FC<Props> = ({ birthOn, relationship, fullName }) => {
  const relationshipTitle = useMemo(() => relationship
    ? `${capitalize(relationship.replace(REGEXPS.DASH_SYMBOL, ' '))}, `
    : '', [relationship]);

  return (
    <Box direction="row">
      {fullName ? (<Inscription
        size="medium"
        color="textBody"
        data-testId="DependentsFullName"
      >
        {fullName}
                   </Inscription>) : null}
      <Inscription
        size="medium"
        color="textSecondary"
        margin={{ left: 'spacing4' }}
        data-testId="DependentsAge"
      >
        ({relationshipTitle}{getYearsOldTitle(birthOn)})
      </Inscription>
    </Box>
  );
};

export default DependentsAge;
